import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { type VanishedDialogViewModel } from './VanishedDialogViewModel'
import { VanishedDialog } from '@/features/opportunities/VanishedDialog'

export interface VanishedDialogContainerProps {
  vm: VanishedDialogViewModel
}

export const VanishedDialogContainer = observer(
  function VanishedDialogContainer({ vm }: VanishedDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <VanishedDialog
        corporateMode={shellInfo.corporateMode}
        showing={vm.modal.showing}
        message={vm.message}
        onClose={vm.modal.close}
      />
    )
  },
)
